import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class Newsletter {
    constructor(container) {
        this.container = container;
        this.bg = container.querySelector('.newsletter__bg');
        this.title = container.querySelector('.newsletter__title');
        this.inputWrapper = container.querySelector('.newsletter__input-wrapper');
        this.terms = container.querySelector('.newsletter__terms');

        this.init();
    }

    init = () => {

        if (this.bg) {
            gsap.fromTo(this.bg, { scale: 1.4 }, { scale: 1, ease: 'expo.out', scrollTrigger: { trigger: this.container, start: 'top 85%', }, });
        }

        const fadeEls = [this.inputWrapper, this.terms].filter(Boolean);

        fadeEls.forEach((el, i) => {
            gsap.fromTo(el, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.7, ease: 'power2.out', delay: i * 0.1, scrollTrigger: { trigger: el, start: 'top 85%', }, });
        });

        if (this.title) {
            const lineSplit = new SplitText(this.title, { type: 'lines', linesClass: 'newsletter-split-line' });

            lineSplit.lines.forEach((line) => {
                const charSplit = new SplitText(line, { type: 'chars' });
                const chars = charSplit.chars;
                const mid = (chars.length - 1) / 2;

                chars.forEach((char, i) => {
                    const distFromCenter = Math.abs(i - mid);
                    const xFrom = i < mid ? -20 : i > mid ? 20 : 0;

                    gsap.fromTo(char, { opacity: 0, x: xFrom }, { opacity: 1, x: 0, duration: 0.5, ease: 'power2.out', delay: distFromCenter * 0.03, scrollTrigger: { trigger: this.title, start: 'top 85%', }, });
                });
            });
        }
    };
}
